import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Assuming you use react-router
import '../styles/Dashboard.css';

function Dashboard() {
  const [status, setStatus] = useState('loading');
  const [insights, setInsights] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStatus = async () => {
      const resp = await fetch('https://localhost:5000/get-research-status', {
        credentials: 'include',
      });

      if (resp.status === 401) {
        // Token expired or not authenticated, redirect to login
        navigate('/login');
        return;
      }

      const data = await resp.json();
      if (data.status === 'not_started') {
        // Start the research
        const startResp = await fetch('https://localhost:5000/start-research', {
          method: 'POST',
          credentials: 'include',
        });

        if (startResp.status === 401) {
          navigate('/login');
          return;
        }

        setStatus('in_progress');
      } else if (data.status === 'in_progress') {
        setStatus('in_progress');
      } else if (data.status === 'completed') {
        setStatus('completed');
        console.log('data: ', data);
        setInsights(data.insights);
      }
    };

    fetchStatus();

    const interval = setInterval(() => {
      if (status === 'in_progress') {
        fetchStatus();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [status, navigate]);

  if (status === 'in_progress' || status === 'loading') {
    return (
      <div>
        IntenceAI is analyzing your data and researching your market... Please
        wait.
      </div>
    );
  }

  if (status === 'completed') {
    return (
      <div className="dashboard-page">
        <h2>Dashboard</h2>
        <h3>Your Market Insights</h3>
        <div className="dashboard-insights">
          <pre>{JSON.stringify(insights, null, 2)}</pre>
        </div>

        {insights && insights.draft_tweets && (
          <div>
            <h3>Your Scheduled Tweets for the Week</h3>
            <ul>
              {insights.draft_tweets.map((t, idx) => (
                <li key={idx}>
                  <strong>{t.tweetNumber}:</strong>
                  {Array.isArray(t.tweet) ? (
                    // Render threads as a nested list
                    <ul>
                      {t.tweet.map((threadPart, threadIdx) => (
                        <li key={threadIdx}>
                          {threadIdx === 0 ? (
                            <strong>{threadPart}</strong>
                          ) : (
                            threadPart
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    // Render single tweets directly
                    <span>{t.tweet}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }

  return <div>Loading...</div>;
}

export default Dashboard;
